module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as2801-cfd41205db1938316ebe11900215b34e.jpg";